import { forAllCallback } from '../../../../kwp/scripts/utils/helpers';
export default (function () {
    forAllCallback('.content-block.content-block--formidable-form', function (el) {
        var formFields = el.querySelectorAll('.form-field');
        var deselectAll = function () {
            formFields.forEach(function (formField) {
                var _a, _b, _c;
                var input = (_a = formField.querySelector('input')) === null || _a === void 0 ? void 0 : _a.value;
                var select = (_b = formField.querySelector('select')) === null || _b === void 0 ? void 0 : _b.value;
                var textarea = (_c = formField.querySelector('textarea')) === null || _c === void 0 ? void 0 : _c.value;
                if (select == 'Please Select') {
                    select = '';
                }
                if (input || select || textarea) {
                    formField.classList.add('selected');
                }
                else {
                    formField.classList.remove('selected');
                }
            });
        };
        formFields.forEach(function (formField) {
            formField.addEventListener('focusin', function () {
                deselectAll();
                formField.classList.add('selected');
            });
            formField.addEventListener('focusout', function () {
                deselectAll();
            });
        });
        deselectAll();
    });
});
